module.exports = __webpack_public_path__ + "static/media/gear-setting-preferences-svgrepo-com.f687a59f.svg";